import React from 'react';

function MoreProductsCard({ pdfUrl, onContactUs }) {
  return (
    <div className="product-card more-products-card">
      <div className="more-products-card-body">
        <span className="more-products-badge">Catalog</span>
        <h3 className="product-name more-products-title">More Products</h3>
        <p className="more-products-text">
          View the full catalog or contact us directly for additional products and bulk
          inquiries.
        </p>
      </div>

      <div className="more-products-actions">
        <a
          className="contact-btn more-products-btn more-products-btn-primary"
          href={pdfUrl}
          target="_blank"
          rel="noreferrer"
        >
          See products
        </a>
        <button
          type="button"
          className="contact-btn more-products-btn more-products-btn-secondary"
          onClick={onContactUs}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
}

export default MoreProductsCard;
